module.exports = __webpack_public_path__ + "icons/bankIcon.b6c542ed066fc7165e03097555cfa755.svg";